import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_NOTIFICATION_DUPLICATE_RECIPIENTS,
} from '../../EmailCreationForm.constants'

import {
  findDuplicateRecipientEmails,
  getDuplicateRecipientOptionKeys,
  removeDuplicateRecipientEmails,
} from './useDuplicateRecipientsValidation.utils'

export function useDuplicateRecipientsValidation({
  printer,
  removeNotification,
  setNotification,
}) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const [showHighlight, setShowHighlight] = useState(false)

  const duplicateOptionKeys = showHighlight
    ? getDuplicateRecipientOptionKeys({ printer, values })
    : new Set()

  function removeDuplicateNotification() {
    removeNotification(EMAIL_CREATION_FORM_NOTIFICATION_DUPLICATE_RECIPIENTS)
  }

  function handleResolveDuplicates() {
    const next = removeDuplicateRecipientEmails({ printer, values })

    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_TO,
      next[EMAIL_CREATION_FORM_FIELD_NAME_TO]
    )
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_CC,
      next[EMAIL_CREATION_FORM_FIELD_NAME_CC]
    )
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_BCC,
      next[EMAIL_CREATION_FORM_FIELD_NAME_BCC]
    )

    setShowHighlight(false)

    removeDuplicateNotification()
  }

  function validateNoDuplicates() {
    const duplicates = findDuplicateRecipientEmails({ printer, values })

    if (duplicates.size === 0) {
      setShowHighlight(false)
      removeDuplicateNotification()

      return true
    }

    setShowHighlight(true)

    setNotification({
      actions: [
        {
          callback: handleResolveDuplicates,
          text: t('Email.DeleteDuplicatesBtnKey'),
        },
      ],
      id: EMAIL_CREATION_FORM_NOTIFICATION_DUPLICATE_RECIPIENTS,
      text: t('Email.DuplicateRecipientsErrorKey'),
      type: NOTIFICATION_TYPE.error,
    })

    return false
  }

  return {
    duplicateOptionKeys,
    validateNoDuplicates,
  }
}
